// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2h06v","amount":"Amount_amount__1mCSq","tip":"Amount_tip__1AoJV","tipHeader":"Amount_tipHeader__3d0j_","tipsWrap":"Amount_tipsWrap__2rpSd"};